import { useEffect, useState } from 'react'
import './SettingSlider.css'
import { SliderProps } from './SettingSlider.types'

const TRACK_WIDTH = 215
const THUMB_WIDTH = 20

// Теперь это не жесткие 3 единицы, а 5% от всей длины ползунка
const SNAP_THRESHOLD_PERCENT = 5

export const SettingSlider = ({
	name,
	min,
	max,
	step,
	value,
	onChange,
	initialValue,
	showCenterMarker,
	type
}: SliderProps) => {
	const getPercent = (v: number): number => {
		return ((v - min) / (max - min)) * 100
	}
	const [hasChanged, setHasChanged] = useState(value !== initialValue)
	const [isSnapping, setIsSnapping] = useState(false)

	useEffect(() => {
		setHasChanged(value !== initialValue)
	}, [value, initialValue])

	const markerLeft = (getPercent(initialValue) / 100) * (TRACK_WIDTH - THUMB_WIDTH) + THUMB_WIDTH / 2

	const handleChange = (raw: number) => {
		if (type === 'disabled') return

		const rawPercent = getPercent(raw)
		const initialPercent = getPercent(initialValue)
		const distancePercent = Math.abs(rawPercent - initialPercent)

		if (distancePercent <= SNAP_THRESHOLD_PERCENT && !isSnapping) {
			onChange(initialValue)
		} else {
			if (distancePercent > SNAP_THRESHOLD_PERCENT) {
				setIsSnapping(true)
			}
			onChange(raw)
		}
	}

	const handlePointerUp = () => {
		setIsSnapping(false)
	}

	return (
		<div className={`setting-row ${type}`}>
			<label>{name}</label>
			<div className="setting-slider-wrapper">

				<div className={`setting-slider-track ${type}`}>
					<div
						className={`setting-slider-fill ${type}`}
						style={{ width: `${getPercent(value ?? 0)}%` }}
					/>
				</div>

				{showCenterMarker && (
					<div className={`setting-slider-center-marker ${type}`} />
				)}

				{hasChanged && (
					<div
						className={`setting-slider-initial-marker ${type}`}
						style={{ left: `${markerLeft}px` }}
					/>
				)}

				<input
					className={`setting-slider ${type}`}
					type="range"
					min={min}
					max={max}
					step={step}
					value={value}
					onChange={(e) => handleChange(Number(e.target.value))}
					onPointerUp={handlePointerUp}
					onTouchEnd={handlePointerUp}
				/>

			</div>
		</div>
	)
}